// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___GfdFy","addText":"AddFilterBox__addText___1zLU4","addFilterContainer":"AddFilterBox__addFilterContainer___1_5v4","addIcon":"AddFilterBox__addIcon___2htFm"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/invoices/components/advancedSearch/AddFilterBox.scss
// module id = 1702
// module chunks = 0